require('../modules/web.timers');
var path = require('../internals/path');

module.exports = path.setTimeout;



//////////////////
// WEBPACK FOOTER
// /root/urbanmassage/node_modules/core-js-pure/stable/set-timeout.js
// module id = 1446
// module chunks = 44